



















































































































































import { Component, Vue, Watch  } from "vue-property-decorator";
import AppHeader from "@/layouts/AppHeader.vue";
import AppDrawer from "@/layouts/AppDrawer.vue";
import { AppConstants } from '@/core/Export';
import store from "@/store";
@Component({ components: { AppHeader, AppDrawer } })
export default class AppDefaultLayout extends Vue {
  isRightDrawerOpen: boolean;
  isLeftDrawerOpen: boolean;
  hourOfDay:number;
  greetingMessage : string;
  constructor() {
    super();
    this.isRightDrawerOpen = true;
    this.isLeftDrawerOpen = false;
  }

  created() {
    this.onGetBaseItems();
    this.typeOfGreetingMessage();
    if (this.appEnv.isDisplayMsgsInLogin) {
      this.showLoginGreetingToast();
    }
  }

  onGetBaseItems() {
    store.dispatch(
      AppConstants.StoreActions.GetBaseItem,
      AppConstants.BaseItems.MissingEvent
    );
    store.dispatch(
      AppConstants.StoreActions.GetBaseItem,
      AppConstants.BaseItems.NotSingingReason
    );
  }

  onSetRightDrawerState() {
    this.isRightDrawerOpen = !this.isRightDrawerOpen;
  }

  onActivateApprovalsList(isFromManager: boolean) {
    store.commit(AppConstants.StoreMutations.UpdateIsLeftDrawerOpen, true);
    store.commit(AppConstants.StoreMutations.UpdateLeftDrawerComponnent, AppConstants.DrawerComponnents.ApprovalsList);
    store.commit(AppConstants.StoreMutations.UpdateDrawerParams, { employeeId: this.appEnv.UserInfo.employeeId, isFromManager: isFromManager });
    if (isFromManager) {
      this.onCloseManagerApprovalsListDialog();
    } else {
      this.onCloseEmpApprovalsListDialog();
    }
  }

  onCloseEmpApprovalsListDialog() {
    this.appEnv.isEmpApprovalsListDialogVisible = false;
  }

  showLoginGreetingToast() {
    this.appEnv.isDisplayMsgsInLogin = false;

    this.$nextTick(() => {
      this.$q.notify({
        message: `${this.$t(this.greetingMessage)} <b>${this.displayNameForLogin || ""}</b>`,
        html: true,
        color: "positive",
        position: "bottom",
        timeout: 3000
      });
    });
  }

  typeOfGreetingMessage() {
    let today = new Date();
    this.hourOfDay = today.getHours();
    if(this.hourOfDay>= 5 && this.hourOfDay < 12){
      this.greetingMessage = "msgs.good_morning";
    }
    else if(this.hourOfDay>= 12 && this.hourOfDay < 18){
      this.greetingMessage = "msgs.good_afternoon";
    }
    else{
      this.greetingMessage = "msgs.good_evening";
    }
  }

  onCloseManagerApprovalsListDialog() {
    this.appEnv.isManagerApprovalsListDialogVisible = false;
  }

  onCloseErrorDialog() {
    this.appEnv.isErrorDialogVisible = false;
    this.appEnv.errorDialogMsgs = [];
  }

  get noOfManagerApprovals() {
    if (this.appEnv.UserInfo && this.appEnv.UserInfo.approvals) {
      return this.appEnv.UserInfo.approvals.noOfManagerApprovals;
    }
    return null;
  }

  get displayNameForLogin() {
    return this.appEnv.UserInfo.displayName;
  }

  get appEnv() {
    return store.state.appEnv;
  }

  @Watch("appEnv.isDisplayMsgsInLogin")
  onIsDisplayMsgsInLoginChanged(newValue: boolean) {
    if (!newValue) return;

    this.showLoginGreetingToast();
  }
}
